var map = {
	"./activities.svg": 84664,
	"./arrow_back.svg": 30100,
	"./balance.svg": 60809,
	"./chevron_down.svg": 15447,
	"./countries.svg": 87591,
	"./coverage.svg": 30169,
	"./hamburger.svg": 26440,
	"./keys.svg": 3847,
	"./legal.svg": 61062,
	"./logout.svg": 49993,
	"./menu_close.svg": 44927,
	"./payments.svg": 90082,
	"./settings.svg": 81448,
	"./trades.svg": 67866,
	"./transactions.svg": 76400,
	"./wallet.svg": 9452,
	"./webhooks.svg": 34045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77855;